<!-- <app-nav></app-nav>
<div [ngSwitch]="routeVal">
    <div *ngSwitchDefault>
        <app-verifier-doc-list></app-verifier-doc-list>
    </div>
    <div *ngSwitchCase="'1'">
        <app-verifier-dispute-list></app-verifier-dispute-list>
    </div>
    <div *ngSwitchCase="'2'">
        <app-verifier-offline-request></app-verifier-offline-request>
    </div>
    <div *ngSwitchCase="'3'">
        <app-superverifier-dashboard></app-superverifier-dashboard>
    </div>
</div>
<app-footer></app-footer>
 -->
 <app-common-menu></app-common-menu>